"use strict";
var race_1 = require('../operator/race');
exports.race = race_1.raceStatic;
//# sourceMappingURL=race.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/~/rxjs/observable/race.js
// module id = ../../../../rxjs/observable/race.js
// module chunks = 3